const configuredApiUrl = (process.env.REACT_APP_API_BASE_URL || "").trim();
const isLocalApiUrl = /^(https?:\/\/)?(localhost|127\.0\.0\.1)(:\d+)?\b/i.test(configuredApiUrl);
const API_BASE_URL = process.env.NODE_ENV === "production" && isLocalApiUrl ? "/api" : configuredApiUrl;

async function apiRequest(url, options = {}) {
  const token = localStorage.getItem("accessToken");

  const res = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  // 🔥 HANDLE TOKEN EXPIRY
  if (res.status === 401) {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      window.location.href = "/";
      throw new Error("Authentication required");
    }

    const refreshRes = await fetch(`${API_BASE_URL}/auth/refresh-token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
    });

    const refreshData = await refreshRes.json();

    if (!refreshRes.ok) {
      localStorage.clear();
      window.location.href = "/";
      throw refreshData || { message: "Session expired" };
    }

    localStorage.setItem("accessToken", refreshData.accessToken);
    if (refreshData.refreshToken) {
      localStorage.setItem("refreshToken", refreshData.refreshToken);
    }

    // retry original request
    const retryResponse = await fetch(`${API_BASE_URL}${url}`, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${refreshData.accessToken}`,
      },
    });
    const retryData = await retryResponse.json();
    if (!retryResponse.ok) throw retryData || { message: "Request failed" };
    return retryData;
  }

  const data = await res.json();
  if (!res.ok) throw data || { message: "Request failed" };
  return data;
}

export default apiRequest;